import React, { useCallback, useEffect } from 'react'
import { ElectricitySection } from '../../../ElectricitySection'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

export const ElectricityTab: React.FC = () => {
  const { entity, userId, readOnly } = useAnalysisMode()
  const { getSectionData, updateSectionData, onDataFetched } =
    useAnalysisServices()
  const { setActiveSection } = useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('electricity')
  }, [setActiveSection])

  const handleDataFetched = useCallback(
    (data: any) => {
      onDataFetched('electricity', data)
    },
    [onDataFetched]
  )

  const handleUpdateElectricityData = useCallback(
    async (ent: any, uid: string, category: any) => {
      const result = await updateSectionData('electricity', ent, uid, category)
      handleDataFetched(result)
      return result
    },
    [updateSectionData, handleDataFetched]
  )

  if (!entity || !userId) return null

  return (
    <ElectricitySection
      entity={{
        id: entity.id || entity.land_id || '',
        municipality_id: entity.municipality_id,
        geo_center: entity.geo_center,
        npa:
          entity.address_postal_code_name || entity.address_postal_code || '',
        municipality_name: entity.municipality_name,
        canton_name: entity.canton_name,
      }}
      userId={userId}
      getElectricityData={() => getSectionData('electricity')}
      onDataFetched={handleDataFetched}
      updateElectricityData={handleUpdateElectricityData}
      readOnly={readOnly}
    />
  )
}
